function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("g", null, React.createElement("circle", {
  stroke: "#FFFFFF",
  strokeWidth: 2,
  cx: 17.5,
  cy: 17.5,
  r: 16.5
}), React.createElement("g", {
  transform: "translate(16.482303, 18.243279) scale(-1, 1) translate(-16.482303, -18.243279) translate(5.982303, 8.199801)",
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M11.7015572,1.807502 C11.2076616,1.70579 10.8897341,1.22295469 10.9914461,0.729059151 C11.0931581,0.23516361 11.5759934,-0.0827639676 12.0698889,0.0189480316 C16.6638273,0.965015802 19.991258,4.96476724 20.0855144,9.65416267 C20.1797709,14.3435581 17.0157519,18.4737871 12.4635404,19.6036916 C7.91132892,20.7335961 3.18320252,18.5622767 1.07370446,14.3730845 C-1.03579359,10.1838922 0.0351070425,5.09243084 3.65345413,2.10799151 C4.04246359,1.78713364 4.61792477,1.84238142 4.93878264,2.23139088 C5.25964051,2.62040035 5.20439273,3.19586152 4.81538326,3.51671939 C1.85491747,5.95853339 0.978726044,10.1242745 2.70467899,13.5517955 C4.43063195,16.9793164 8.29909901,18.7558504 12.0236357,17.8313831 C15.7481724,16.9069158 18.3369151,13.5276375 18.2597963,9.69085943 C18.1826774,5.85408136 15.460234,2.58155745 11.7015572,1.807502 Z"
}), React.createElement("path", {
  d: "M3.66833174,3.46974676 L0.929201304,3.46974676 C0.424941315,3.46974676 0.0161578257,3.06096327 0.0161578257,2.55670328 C0.0161578257,2.05244329 0.424941315,1.6436598 0.929201304,1.6436598 L4.58137522,1.6436598 C5.08563521,1.6436598 5.4944187,2.05244329 5.4944187,2.55670328 L5.4944187,6.20887719 C5.4944187,6.71313718 5.08563521,7.12192067 4.58137522,7.12192067 C4.07711523,7.12192067 3.66833174,6.71313718 3.66833174,6.20887719 L3.66833174,3.46974676 Z"
})))));

const SvgRestartSessionIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgRestartSessionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/restart-session-icon.fce6b235.svg";
export { ForwardRef as ReactComponent };